const OilcoReports = {
  FleetAccount: "fleet-account",
  StationAccount: "station-account",
  VoucherClaim: "voucher-claim",
  SupplierWPP: "supplier-wpp",
  Settlements: "settlements",
  FleetPrices: "fleet-prices",
  PricingChanges: "pricing-changes",
  LubeservOnSite: "lubeserv-on-site",
  LubeservOnWheels: "lubeserv-on-wheels",
  VoucherCampaign: "voucher-campaign",
  StationNegotiatedDiscount: "station-negotiated-discount",
  PriceBuildup: "price-buildup",
  CashIn: "cashin",
  Payment: "payment",
  FuelCard: "fuel-card",
  Redemption: "redemption",
  RedemptionItem: "redemption-item",
  CustomerList: "customer-list",
  LoyaltyCards: "loyalty-cards",
  RfidTopup: "rfid-topup",
  MerchantPayment: "merchant-payment",
  KYCSubmission: "kyc-submission",
  VIPTransactionHistory: "vip-award-points",
  VIPPayWithPoints: "vip-pay-with-points",
  VIPRedeemPoints: "vip-redeem-points",
};

const ReportType = {
  CashIn: "cashin",
  BuyFuel: "buy-fuel",
  Redemption: "redemption",
  FleetAccount: "fleet-account",
  FleetPrices: "fleet-prices",
  Settlements: "settlements",
  RedemptionItem: "redemption-item",
  PricingHistory: "pricing-history",
  FuelCode: "fuel-code",
  FuelCodes: "fuel-codes",
  Mops: "mops",
  PricingChanges: "pricing-changes",
  VoucherClaim: "voucher-claim",
  NewCustomerVoucher: "new-customer-voucher",
  PriceBuildup: "price-buildup",
  PriceMovement: "price-movement",
  StationAccount: "station-account",
  CustomerList: "customer-list",
  VoucherCampaign: "voucher-campaign",
  DiscountCampaign: "discount-campaign",
  RfidTopup: "rfid-topup",
  Payment: "payment",
  KYCSubmission: "kyc-submission",
  SupplierWPP: "supplier-wpp",
  LubeservBookings: "lubeserv-bookings",
  StationNegotiatedDiscount: "station-negotiated-discount",
  LubeservOnSite: "lubeserv-on-site",
  LubeservOnWheels: "lubeserv-on-wheels",
  LoyaltyCards: "loyalty-cards",
  MerchantPayment: "merchant-payment",
  VIPTransactionHistory: "vip-award-points",
  VIPPayWithPoints: "vip-pay-with-points",
  VIPRedeemPoints: "vip-redeem-points",
};

export { OilcoReports, ReportType };
